var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-modal-contents", {
        ref: "modal_contents_agree",
        scopedSlots: _vm._u([
          {
            key: "close",
            fn: function () {
              return [_c("div")]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use__title " }, [
                  _c("div", { staticClass: "h2_title" }, [
                    _vm._v("Условия использования персональных данных"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use mt-30 " }, [
                  _c("div", { domProps: { innerHTML: _vm._s(_vm.terms) } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-30" }, [
                    _c(
                      "button",
                      {
                        staticClass: "px-30 btn-red ",
                        on: {
                          click: function ($event) {
                            return _vm.$refs.modal_contents_agree.modal_open()
                          },
                        },
                      },
                      [_vm._v("\n              Прочитал\n            ")]
                    ),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "form",
          staticClass:
            " formNew_wrap wow fadeIn form_konteyner_polimernyy_footer",
          attrs: { "data-wow-delay": "0.3s", "lazy-validation": "" },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            "div",
            { staticClass: "row mx-0 my-0" },
            [
              _vm._t("description", function () {
                return [
                  _c("div", { staticClass: "col-12 col-md-6 col-lg-6 p-md-2" }),
                ]
              }),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-md-6 col-lg" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-md-6 pb-3 px-3 pt-3" }, [
                    _c(
                      "div",
                      { staticClass: "formNew_wrap__item" },
                      [
                        _c("v-text-field", {
                          staticClass: "form__input",
                          attrs: {
                            rules: [_vm.rules.required, _vm.rules.ruleTownName],
                            required: "",
                            id: "name",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                    ФИО *\n                  "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.name,
                            callback: function ($$v) {
                              _vm.name = $$v
                            },
                            expression: "name",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-6 pb-3 px-3 pt-3" }, [
                    _c(
                      "div",
                      { staticClass: "formNew_wrap__item" },
                      [
                        _c("v-text-field", {
                          staticClass: "form__input",
                          attrs: { rules: [_vm.rules.ruleOrg], id: "company" },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                    Компания\n                  "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.company,
                            callback: function ($$v) {
                              _vm.company = $$v
                            },
                            expression: "company",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-6 pb-3 px-3 pt-3" }, [
                    _c(
                      "div",
                      { staticClass: "formNew_wrap__item" },
                      [
                        _c("v-text-field", {
                          staticClass: "form__input",
                          attrs: {
                            rules: [_vm.rules.mail],
                            oninput: "this.value = this.value.trim()",
                            id: "email",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                    Электронная почта\n                  "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.email,
                            callback: function ($$v) {
                              _vm.email = $$v
                            },
                            expression: "email",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-6 pb-3 px-3 pt-3" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "formNew_wrap__item item_tel position-relative",
                      },
                      [
                        _c("v-text-field", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "# ### ###-##-##",
                              expression: "'# ### ###-##-##'",
                            },
                          ],
                          staticClass: "pl-0 form__input",
                          attrs: {
                            rules: [_vm.rules.required],
                            required: "",
                            id: "tel",
                            oninput:
                              "this.value = this.value.replace(/^\\(8/, '(');",
                            max: "20",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                    Телефон *\n                  "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.tel_input,
                            callback: function ($$v) {
                              _vm.tel_input = $$v
                            },
                            expression: "tel_input",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-12 pb-3 px-3 pt-3" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "formNew_wrap__item  position-relative form_cooperation__item directionСoop",
                        },
                        [
                          _c("v-select", {
                            staticClass: "form_cooperation__input ",
                            attrs: {
                              items: _vm.traySizeItems,
                              "item-value": "id",
                              label: "Размер лотка, мм",
                              required: "",
                              "append-icon": "mdi mdi-chevron-down",
                              id: "traySizeItems",
                              "menu-props": { contentClass: "traySizeItems" },
                              "return-object": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.name) +
                                        "\n                  "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "selection",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.name) +
                                        "\n                  "
                                    ),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.selectTraySize,
                              callback: function ($$v) {
                                _vm.selectTraySize = $$v
                              },
                              expression: "selectTraySize",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-12 pb-3 px-3 pt-3" },
                    [
                      _c(
                        "div",
                        { staticClass: "formNew_wrap__item" },
                        [
                          _c("v-textarea", {
                            staticClass: "form__input",
                            attrs: { rows: "3", id: "message" },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      "\n                    Комментарий\n                  "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.message,
                              callback: function ($$v) {
                                _vm.message = $$v
                              },
                              expression: "message",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-12 pb-3 px-3 pt-3" },
                    [
                      _c("div", {
                        staticClass: "w-100 mt-30",
                        class: _vm.captchaPassed ? "" : "error-captcha",
                        attrs: { id: "captcha-container" },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "formNew_wrap__item  mt-30" },
                        [
                          _c("v-checkbox", {
                            attrs: {
                              rules: [
                                function (v) {
                                  return !!v || "Это обязательный пункт"
                                },
                              ],
                              required: "",
                              color: "red",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "customLabelForm" },
                                      [
                                        _vm._v(
                                          "\n                      Я выражаю согласие с "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: "javascript:void(0);",
                                              target: "_blank",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.$refs.modal_contents_agree.modal_open(
                                                  "scroll_false"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "условиями\n                      использования"
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          " моих персональных данных для обработки данного обращения\n                      ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская область,\n                      г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2), я ознакомлен и выражаю\n                      согласие с\n                      "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "position-relative zi-1",
                                            attrs: { href: _vm.policy },
                                            on: {
                                              click: function ($event) {
                                                return _vm.linkOpen(_vm.policy)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "Политикой\n                        конфиденциальности"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" и "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "position-relative zi-1",
                                            attrs: { href: _vm.agreement },
                                            on: {
                                              click: function ($event) {
                                                return _vm.linkOpen(
                                                  _vm.agreement
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "Пользовательским\n                      соглашением."
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.checkbox,
                              callback: function ($$v) {
                                _vm.checkbox = $$v
                              },
                              expression: "checkbox",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-checkbox", {
                            staticClass: "mt-0",
                            attrs: { color: "red" },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "customLabelForm" },
                                      [
                                        _vm._v(
                                          "\n                      Я выражаю согласие на информирование меня о продуктах, акциях, выгодных\n                      предложениях, новостях ООО «Компания Нова Ролл» (ИНН 5038050970, адрес:\n                      141206, Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5,\n                      этаж 2) и\n                      партнеров.\n                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.consentToInform,
                              callback: function ($$v) {
                                _vm.consentToInform = $$v
                              },
                              expression: "consentToInform",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "btn_form d-flex align-items-center  ",
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: " btn-red w-mc",
                                  attrs: { disabled: !_vm.valid },
                                  on: { click: _vm.sendForm },
                                },
                                [
                                  _vm._v(
                                    "\n                    Отправить\n                  "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
              ]),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }